import React from 'react';
import { defineMessages } from 'react-intl.macro';
import { useMessage } from '@tmapy/intl';
import { useDispatch, useSelector } from '@tmapy/redux';

import { Zoom as ZoomButton } from '@tmapy/mapcore';

const msgZoom = defineMessages({
  inTooltip: { id: 'zoom.inTooltip', defaultMessage: 'Přiblížit' },
  outTooltip: { id: 'zoom.outTooltip', defaultMessage: 'Oddálit' },
});

export const Zoom: React.FC = () => {
  const dispatch = useDispatch();
  const view = useSelector((state) => state.mapCore.view);
  const formatMessage = useMessage();

  return (
    <ZoomButton
      inTooltip={formatMessage(msgZoom.inTooltip)}
      outTooltip={formatMessage(msgZoom.outTooltip)}
      dispatch={dispatch}
      view={view}
    />
  );
};
